import React from "react";
import { Busy } from "../presentational/busy";
import ReactGA from "react-ga";
import styles from "../../styles/panels/codeError.css";

export class CodeError extends React.Component {
  constructor(props) {
    super(props);
    let banner = this.props.images.share_banners[
      Math.floor(Math.random() * this.props.images.share_banners.length)
    ];
    this.state = {
      banner: banner
    };
  }
  componentDidMount() {
    ReactGA.pageview("/Spend/CodeError");
    if (!this.props.code) {
      this.props.onEmptyCode();
    }
  }
  render() {
    if (this.props.busy) {
      return <Busy />;
    } else {
      return (
        <div className={styles.main}>
          <div
            className={styles.banner}
            style={{ backgroundImage: "url(" + this.state.banner.src + ")" }}
          />
          <div className={styles.content}>
            {this.props.selectedCharities.length > 0 ? (
              <div>
                <div className={styles.header}>
                  {this.props.dictionary.code_error_header_spent
                    .replace("[CODE]", this.props.code)
                    .replace("[DATESPENT]", this.props.dateSpent)}
                </div>
                <div className={styles.message}>
                  {this.props.dictionary.code_error_message_spent}
                </div>
                <ul>
                  {this.props.selectedCharities.map(charity => {
                    return <li>{charity.name}</li>;
                  })}
                </ul>
              </div>
            ) : (
              <div>
                <div className={styles.header}>
                  {this.props.dictionary.code_error_header}
                </div>
                <div className={styles.message}>
                  {this.props.dictionary.code_error_message}
                </div>
                <div
                  className={styles.information}
                  dangerouslySetInnerHTML={{
                    __html: this.props.dictionary.code_error_information
                  }}
                />
              </div>
            )}
          </div>
        </div>
      );
    }
  }
}
